import { MINIMUM_ROW_HEIGHT } from './UIConstants';


import { getPointsFromLs, unit, minus, scale, add } from './Geometry';

export function computeFromHorizAdj(start,end,info){

  let deltaX = end[0] - start[0];

  let { inlineCrop, cellWidthOfCropBeingAdjusted,side } = info;

  if( !inlineCrop ){
    debugger;
  }

  let change = (deltaX * inlineCrop.width / cellWidthOfCropBeingAdjusted);
  if( side === 'left' ){
    change *= -1;
  }

  let hOverWConstant =  inlineCrop.height / inlineCrop.width ;
  let newWidth = inlineCrop.width - change;
  let newHeight = newWidth * hOverWConstant;

  //let heightChange = (totalArea / (inlineCrop.width - change)) - inlineCrop.height; 

  let heightChange = newHeight - inlineCrop.height;
  let newTop = inlineCrop.top - (heightChange/2);

  let newInlineCrop = {
    ...inlineCrop,
    width:newWidth,
    top:newTop,
    height:newHeight //inlineCrop.height + heightChange
  }
  if( side === 'left' ){
    newInlineCrop.left = inlineCrop.left + change;
  }
  return newInlineCrop;
}

export function getUpdatedLsFromInlineCrop(start,end,info,tempInlineCrop){

  let { inlineCrop, side, annotation } = info;

  /*let tempInlineCrop = computeFromHorizAdj(
    start,end,info
  )*/

  let newHeight = tempInlineCrop.height;
  let oldHeight = inlineCrop.height;
  let halfHeightDelta = (newHeight - oldHeight) / 2; 
  halfHeightDelta *= (side === 'top' ? -1 : 1);

    let [p0,p1,p2,p3] = getPointsFromLs(annotation.ls, oldHeight);


  let unitLs = unit(minus(annotation.ls[1],annotation.ls[0]))

  let unitLsPerp = unit(minus(p3,p0));

  if( ['left','right'].includes(side) ){
    halfHeightDelta = 0;
  }

  let shifter = scale(halfHeightDelta,unitLsPerp)

  let newLs = annotation.ls.map(point => add(point, shifter));

  let leftDelta = (tempInlineCrop.left - inlineCrop.left);
  let rightDelta = (tempInlineCrop.width - inlineCrop.width);

  let deltaY = end[1] - start[1];

  if( side === 'left' ){
    rightDelta = 0;
  }


  let newLs0 = add( newLs[0], scale(leftDelta, unitLs) )
  let newLs1 = add( newLs[1], scale(rightDelta, unitLs) )

  let lsUpdatedWithHorizontalChanges = [
    newLs0,
    newLs1
  ]

  return {
    ls:lsUpdatedWithHorizontalChanges,
    height:newHeight
  }

}

export function computeFromVertTop(start,end,info){

  let deltaY = end[1] - start[1];

  let { inlineCrop, cellWidthOfCropBeingAdjusted } = info;

  let change = -(deltaY * inlineCrop.width / cellWidthOfCropBeingAdjusted )

  let potentialNewHeight = inlineCrop.height + change;

  let potentialNewCellHeight = cellWidthOfCropBeingAdjusted * (potentialNewHeight / inlineCrop.width);


  let mrh = MINIMUM_ROW_HEIGHT;
  let mrhString = mrh + "";
  if( potentialNewCellHeight < MINIMUM_ROW_HEIGHT ){
    debugger;
    return {
      height:MINIMUM_ROW_HEIGHT,
      crop:inlineCrop,
    };
  }


  let newTempInlineCrop = ({
    ...inlineCrop,
    top:inlineCrop.top - change,
    height:potentialNewHeight,
    translate:deltaY
  })

  return {
    height:potentialNewHeight,
    crop:newTempInlineCrop
  }


  /*
  localDispatch({
    verticalImageResizeTranslation:{
      untilRowIndex:cellLocation[0],
      y:deltaY
    }
  })
  */

}


export function computeFromVertBottom(start,end,info){

  let deltaY = end[1] - start[1];
  let { inlineCrop, cellWidthOfCropBeingAdjusted } = info;

  let potentialNewHeight = inlineCrop.height + (deltaY * inlineCrop.width / cellWidthOfCropBeingAdjusted );

  let potentialNewCellHeight = cellWidthOfCropBeingAdjusted * (potentialNewHeight / inlineCrop.width);

  if( potentialNewCellHeight < MINIMUM_ROW_HEIGHT ){

    return {
      height:MINIMUM_ROW_HEIGHT,
      crop:inlineCrop,
    };
  }

  let newTempInlineCrop = {
    ...inlineCrop,
    height:potentialNewHeight
  }

  return {
    height:potentialNewHeight,
    crop:newTempInlineCrop
  }

  //setTempInlineCrop(newTempInlineCrop)


  /*
   *
   * The localDispatch
   * here is ONLY here because 
   * I saw that adjustments from the top
   * were firing the local onMouseUp event
   * and so I tried it here and this makes it
   * also fire that event.
   */

  /*
        localDispatch({

          verticalImageResizeTranslation:{
            untilRowIndex:0,
            y:0
          }
        })
        */
}
